import { REGISTER_UPLOAD_RESUME } from '../actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case REGISTER_UPLOAD_RESUME:
      if (action.payload.data.success) {
        return {
          status: action.payload.data.success,
          user: action.payload.data.user
        }
      } else {
        return {
          status: action.payload.data.success,
          message: action.payload.data.error
        }
      }
  }
  return state
}
